import {
	apiUrl
} from "src/config/host";
import axios from "axios";
import {
	toast
} from "react-toastify";
import {
	urlBuilder
} from "src/helpers/urlBuilder";
import {
	logoutRedirect
} from "./fetch";
const refreshTokenVerify = async () => {
	const refreshTokenRes = await fetch(`${apiUrl}/portal/refresh-token/verify`, {
		method: "POST",
		headers: new Headers({
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: `Bearer ${localStorage.getItem("refreshToken")}`,
		}),
		body: JSON.stringify({}),
	});
	let refreshTokenData = {};
	if (refreshTokenRes.status === 200) {
		refreshTokenData = await refreshTokenRes.json();
		localStorage.setItem("email", refreshTokenData?.email);
		localStorage.setItem("accessToken", refreshTokenData.access_token);
		localStorage.setItem("refreshToken", refreshTokenData.refresh_token);
		localStorage.setItem("isSubDomain", refreshTokenData?.isSubDomain);
	}
	return {
		refreshTokenRes,
		refreshTokenData
	};
};
const builderQueryString = (queries = []) => {
	let queryString = "";
	if (queries) {
		const filteredQueries = Object.fromEntries(Object.entries(queries).filter(([key, value]) => value != null));
		queryString = new URLSearchParams(filteredQueries);
		queryString = "?" + queryString.toString();
	}
	return queryString;
};
const ongoingRequests = new Map(); // Map to track ongoing requests by dynamic URL
const apiRequest = async (method = "put", url = "", payload = {
	body: null,
	params: {},
	queries: null
}, options = {
	useCustomUrl: false,
	responseType: "json",
	onDownloadProgress: () => {},
	showToastMessage: false,
	signal: null,
	headers: {},
	returnErrorWithstatus: false,
	is_abort: true
}, ) => {
	let params = payload.params;
	delete payload.params;
	let defaultPayload = {
		body: null,
		queries: null
	};
	payload = {
		...payload,
		defaultPayload
	};
	let defaultOptions = {
		useCustomUrl: false,
		showToastMessage: false,
		signal: null,
		headers: {}
	};
	options = {
		...options,
		defaultOptions
	};
	try {
		let queryString = "";
		if (payload.queries != null) {
			queryString = builderQueryString(payload?.queries);
		}
		let accessToken = localStorage.getItem("accessToken") || payload.body?.token || options.headers?.Authorization || null;
		const loginWorkspaceId = localStorage.getItem("loginWorkspaceId");
		let headers = {
			"Content-Type": "application/json",
			Accept: "application/json"
		};
		headers = {
			...headers,
			...(accessToken ? {
				Authorization: `Bearer ${accessToken}`
			} : {}),
			...(loginWorkspaceId ? {
				"x-workspace-id": loginWorkspaceId
			} : {}),
			...options.headers,
		};
		// Construct the dynamic URL
		const dynamicUrl = urlBuilder(url, params || {});
		// Check if there's an ongoing request for the same dynamic URL
		if (ongoingRequests.has(dynamicUrl)) {
			// Abort the ongoing request associated with the dynamic URL
			ongoingRequests.get(dynamicUrl).abort();
		}
		let signal = null;
		if (options.is_abort) {
			const controller = new AbortController();
			ongoingRequests.set(dynamicUrl, controller);
			signal = options.signal || controller.signal;
		}
		let request = axios.create({
			baseURL: options.useCustomUrl ? "" : apiUrl,
			responseType: options.responseType || "json",
			onDownloadProgress: options.onDownloadProgress,
			headers,
			signal,
			withCredentials: true,
		});
		let res = await request[method.toLowerCase()](`${urlBuilder(url, params)}${queryString}`, payload.body);
		if (res?.status === 403 || res?.data?.status === 403 || res?.data?.status === "inactive" || res?.data?.status === "client_inactive") {
			const resCode = res?.data?.code;
			if (["WORKSPACE_PAUSED", "WORKSPACE_PAUSED_SCHEDULED"].includes(resCode)) {
				if (!options?.returnErrorWithstatus && !window.location.pathname.includes("workspace-paused")) {
					const pathSegments = window.location.pathname.split("/");
					const workspace_id = (pathSegments[1] === "workspace" && pathSegments[2]) || localStorage.getItem("workspace") || localStorage.getItem("loginWorkspaceId") || res?.data?.workspace_id || "";
					const targetUrl = workspace_id ? `/workspace/${workspace_id}/workspace-paused` : "/workspace-paused";
					window.location.href = targetUrl;
				}
			} else {
				if (!options?.returnErrorWithstatus && !window.location.pathname.includes("client-inactive")) {
					window.location.href = res?.data?.redirect || "/client-inactive";
				}
			}
		}
		if (res.status === 401 && res.data?.expired) {
			const {
				refreshTokenRes,
				refreshTokenData
			} = await refreshTokenVerify();
			if (refreshTokenRes.status === 200) {
				headers.Authorization = refreshTokenData.refresh_token;
				request = axios.create({
					baseURL: options.useCustomUrl ? "" : apiUrl,
					headers,
				});
				res = await request[method.toLowerCase()](`${urlBuilder(url, params)}${queryString}`, payload.body, {
					signal: options.signal
				});
			}
		}
		if (res.status >= 200 && res.status < 300) {
			if (options.showToastMessage) {
				if (res.data?.message) {
					toast.success(res.data?.message);
				}
				if (res.data?.data?.message) {
					toast.success(res.data?.data?.message);
				}
			}
			ongoingRequests.delete(dynamicUrl); // Remove the dynamic URL from ongoing requests
			return res;
		} else {
			if (options.showToastMessage) {
				if (res.data?.message) {
					toast.error(res.data?.message);
				}
				if (res.data?.data?.message) {
					toast.error(res.data?.data?.message);
				}
			}
			if (options?.returnErrorWithstatus) {
				if (res && typeof res === "object") {
					res.response = res;
				}
				throw res;
			}
			throw new Error(res?.message || res);
		}
	} catch (error) {
		if (error?.response) {
			const errStatus = error.response.status;
			const errData = error.response.data;
			const errCode = errData?.code;
			if (errStatus === 403 || errData?.status === 403 || errData?.status === "inactive" || errData?.status === "client_inactive") {
				if (["WORKSPACE_PAUSED", "WORKSPACE_PAUSED_SCHEDULED"].includes(errCode)) {
					if (!options?.returnErrorWithstatus && !window.location.pathname.includes("workspace-paused")) {
						const pathSegments = window.location.pathname.split("/");
						const workspace_id = (pathSegments[1] === "workspace" && pathSegments[2]) || localStorage.getItem("workspace") || localStorage.getItem("loginWorkspaceId") || errData?.workspace_id || "";
						const targetUrl = workspace_id ? `/workspace/${workspace_id}/workspace-paused` : "/workspace-paused";
						window.location.href = targetUrl;
						return;
					}
				} else {
					if (!options?.returnErrorWithstatus && !window.location.pathname.includes("client-inactive")) {
						window.location.href = errData?.redirect || "/client-inactive";
						return;
					}
				}
			}
		}
		if (error?.response?.status === 401 && error?.response?.data?.expired) {
			const queryString = builderQueryString(payload?.queries);
			const {
				refreshTokenRes,
				refreshTokenData
			} = await refreshTokenVerify();
			if (refreshTokenRes.status === 200) {
				let headers = {
					"Content-Type": "application/json",
					Accept: "application/json"
				};
				headers = {
					...headers,
					Authorization: `Bearer ${refreshTokenData.refresh_token}`,
					...options.headers,
				};
				const request = axios.create({
					baseURL: options.useCustomUrl ? "" : apiUrl,
					headers,
				});
				const res = await request[method.toLowerCase()](`${urlBuilder(url, params)}${queryString}`, payload.body, {
					signal: options.signal
				});
				if (res.status === 200) {
					if (options.showToastMessage) {
						if (res.data?.message) {
							toast.success(res.data?.message);
						}
						if (res.data?.data?.message) {
							toast.success(res.data?.data?.message);
						}
					}
					return res;
				} else {
					if (options.showToastMessage) {
						if (res.data?.message) {
							toast.error(res.data?.message);
						}
						if (res.data?.data?.message) {
							toast.error(res.data?.data?.message);
						}
					}
					if (options?.returnErrorWithstatus) {
						const errObj = res || error?.response || error;
						if (errObj && typeof errObj === "object") {
							errObj.response = errObj;
						}
						throw errObj;
					}
					throw new Error(res?.message || res);
				}
			} else {
				// localStorage.removeItem('access_token')
				// localStorage.removeItem('refresh_token')
				// window.location.href = '/login'
				if (options.showToastMessage) {
					toast.error(error?.response?.data?.message || error?.response?.data);
				}
				if (options?.returnErrorWithstatus) {
					const errObj = error?.response || error;
					if (errObj && typeof errObj === "object") {
						errObj.response = errObj;
					}
					throw errObj;
				}
				throw new Error(error?.response?.data?.message || error?.response?.data || error);
			}
		} else if (error?.response?.status === 401 && error?.response?.data?.invalid) {
			logoutRedirect();
		} else {
			if (axios.isCancel(error) || error?.name === "CanceledError" || error?.code === "ERR_CANCELED" || error?.message === "canceled") {
				throw error;
			}
			if (options.showToastMessage) {
				toast.error(error?.response?.data?.message || error?.response?.data);
			}
			if (options?.returnErrorWithstatus) {
				const errObj = error?.response || error;
				if (errObj && typeof errObj === "object") {
					errObj.response = errObj;
				}
				throw errObj;
			}
			throw new Error(error?.response?.data?.message || error?.response?.data || error);
		}
	}
};
export {
	builderQueryString,
	apiRequest
};
